import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHeartBeat: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconHeartBeat"><Path d="M17.5 11.5H15L13.5 14L10.5 9L9 11.5H6.5M12 5.37552C18.5042 -1.25346 29.6544 11.0575 12 21C-5.65441 11.0576 5.4957 -1.25346 12 5.37552Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconHeartBeat;
